import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core';
import { AuthService } from 'src/app/core/auth.service';
import { Validators, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { EmployeeProfileApi, EmployeeProfileEditComment, ImmigrationComment, ImmigrationCommentApi } from 'src/app/core/api.gen';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'eos-profile-comments',
  templateUrl: './immigration-comments.component.html',
  styleUrls: ['./immigration-comments.component.css']
})
export class EmployeeProfileCommentsComponent implements OnInit {


  @Input() public readonly?: boolean;
  @Input() public commentType: number;
  @Input() public profileId: number;
  @Input() public profileStatusId: number;

  editMode = false;
  employeeId: number;
  comments: EmployeeProfileEditComment[] = [];

  commentForm = new UntypedFormGroup({
    comment: new UntypedFormControl('', [Validators.required]),
    profileId: new UntypedFormControl(null),
    commentType: new UntypedFormControl(null),
    statusId: new UntypedFormControl(null),
    id: new UntypedFormControl(0)
  });

  constructor(
      private toast: ToastService,
      private authService: AuthService,
      private employeeApi: EmployeeProfileApi,
      public modal: NgbActiveModal,
      ) { }

  ngOnInit() {
    this.employeeId = this.authService.ActiveUser.employeeId;
    this.loadComments();
    // this.setForm();
  }

  loadComments() {
      this.employeeApi.getComments(this.profileId).subscribe(resp => {
          this.comments = resp;
      })
    // this.employeeApi.getComments(this.profileId)
    //   .subscribe(resp => {
    //     this.comments = resp;
    //   });
  }

  get DisableSaveUpdate(): boolean {
    return !this.commentForm.valid || this.readonly;
  }



  save() {
    
  }


  editComment(comm: ImmigrationComment) {
    this.editMode = true;
    this.commentForm.patchValue({
      commentType: comm.commentType,
      statusId: this.profileStatusId,
      profileId: this.profileId,
      comment: comm.comment,
      id: comm.id
    });
  }

  setForm() {
    this.commentForm.patchValue({
      commentType: this.commentType,
      statusId: this.profileStatusId,
      profileId: this.profileId,
      comment: '',
      id: 0
    });
  }

}
